import React from 'react'
import {
  UploadFormWrapper,
  useInputIsVisible,
  FormDataFilter as FormFilter,
} from '@modifi/plugin-onboarding'
import {Col} from '@modifi/ui'

import {ColSizeProps, FormDataFilterFunc, TranslateFn} from '../../../../types/common'

type FormUploadComponentColProps = {
  inputName: string
  filterFunc?: FormDataFilterFunc | null
  filterParams?: Record<string, unknown>
  uploadFormComponent: React.ElementType
  t: TranslateFn
  inputFieldNames?: string[]
  inputProps?: Record<string, unknown>
  colProps?: ColSizeProps
}

const FormUploadComponentCol: React.FC<FormUploadComponentColProps> = ({
  inputName,
  filterFunc = null,
  filterParams = {},
  uploadFormComponent,
  inputFieldNames,
  t,
  colProps,
  inputProps = {},
  ...restProps
}) => {
  const isInputVisible = useInputIsVisible(inputName)

  const FormDataFilter = filterFunc ? FormFilter : React.Fragment

  const filterObj = filterFunc ? {filterFunc, filterParams} : {}

  if (!isInputVisible) {
    return null
  }
  return (
    <>
      {/*
     // @ts-expect-error filterFunc prop wont be undefined since there is a null check above   */}
      <FormDataFilter {...filterObj}>
        <Col col={colProps?.col || 12} md={colProps?.md || 6}>
          <UploadFormWrapper
            name={inputName}
            uploadFormComponent={uploadFormComponent}
            t={t}
            inputFieldNames={inputFieldNames}
            hideTooltip
            {...inputProps}
            {...restProps}
          />
        </Col>
      </FormDataFilter>
    </>
  )
}

export default FormUploadComponentCol
